import { parser } from '@/utils/parser'

export const state = () => ({
  excursions: [],
  meta: null,
  pending: false
})

export const mutations = {
  clear: (state) => {
    state.excursions = []
    state.meta = null
  },
  setExcursions: (state, excursions) => state.excursions = [...state.excursions, ...excursions],
  setMeta: (state, meta) => state.meta = meta,
  setPending: (state, pending) => state.pending = pending
}

export const actions = {
  async fetch ({ commit }, payload) {
    commit('setPending', true)
    if (payload?.clear) {
      commit('clear')
    }
    const excursions = await this.$axios.$get(`/api/excursions?${parser(payload)}`)
    commit('setExcursions', excursions.data)
    commit('setMeta', excursions.meta)
    commit('setPending', false)
  }
}

export const getters = {
  excursions: state => state.excursions,
  meta: state => state.meta,
  pending: state => state.pending
}
